<template>
    <div class="B2BArticles border-b-[56px] border-solid border-gray-100 dark:border-default bg-black text-white xl:border-b-[200px]">
        <div class="container flex flex-col pb-4 pt-20 xl:pb-48">
            <div class="flex w-full flex-col items-center justify-between xl:flex-row">
                <CHeading tag="h2" variant="fat-italic">Nenašli ste vyhovujúce riešenie? Poďme ho zostaviť na mieru.</CHeading>

                <CText class="ml-0 mt-4 xl:ml-14 xl:mt-0" variant="muted">
                    Spolu s organizáciou LEAF sme vytvorili riešenie aj pre Slovenskú sporiteľňu. Prečítaj si viac o
                    našich spoluprácach nižšie.
                </CText>
            </div>

            <div class="mt-4 flex flex-col lg:flex-col-reverse xl:mt-14 xl:flex-row">
                <CButton class="mb-2 mt-0 h-14 w-40 lg:mx-auto lg:my-4 xl:m-0" href="#formular" variant="primary">
                    Kontaktujte nás
                </CButton>

                <B2BArticleSlider />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import B2BArticleSlider from '@/components/b2b/B2BArticleSlider.vue'
</script>